import { checkWin } from "@alife/cone-arms-core";
export var registerCNUIPlugin = function(componentName, pluginName, sourceCode) {
    var _window_CNUI_cnUtils, _window_CNUI;
    if (!checkWin()) {
        return;
    }
    var hasRegister = function() {
        if (!Array.isArray(window.CN_UI_PLUGIN)) {
            return false;
        }
        var componentPlugins = window.CN_UI_PLUGIN.find(function(plugin) {
            return plugin.name === componentName;
        });
        if (!componentPlugins || !Array.isArray(componentPlugins.plugins)) {
            return false;
        }
        return componentPlugins.plugins.some(function(plugin) {
            return plugin.name === pluginName;
        });
    };
    var pluginManager = (_window_CNUI = window.CNUI) === null || _window_CNUI === void 0 ? void 0 : (_window_CNUI_cnUtils = _window_CNUI.cnUtils) === null || _window_CNUI_cnUtils === void 0 ? void 0 : _window_CNUI_cnUtils.pluginManager;
    if (typeof pluginManager !== "undefined" && typeof pluginManager.registerPlugin === "function" && !hasRegister()) {
        pluginManager.registerPlugin([
            {
                componentName: componentName,
                plugins: [
                    {
                        name: pluginName,
                        sourceCode: sourceCode
                    }
                ]
            }
        ]);
    }
};
export var checkElementInDialog = function(element) {
    if (!checkWin()) {
        return false;
    }
    if (!element) {
        return false;
    }
    try {
        var _document_querySelector;
        return (_document_querySelector = document.querySelector("[role=dialog]")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.contains(element);
    } catch (err) {
        return false;
    }
};

 //# sourceMappingURL=utils.js.map